module.exports = __webpack_public_path__ + "static/media/foto2.d06c0d34.png";